export default __webpack_public_path__ + "static/media/our-events-mobile-hero.b1689de5.png";